define('lib/view/mixin/BookingResultPopupMixin',['require','Config'],function (require) {

    var Config = require('Config');

    return {

        isShowBookingResultPopup: function(data){
            if(['new'].indexOf(data.status) > -1){
                return false; //ignore this status
            }
            var bookingIds = data.booking_ids;
            if(!Array.isArray(bookingIds)){
                bookingIds = [bookingIds];
            }
            if(this._isPopupDisplayed(data.status, bookingIds, data.invoice_id?data.invoice_id:null)){
                return false; //popup already closed
            }
            this._setPopupDisplayed(data.status, bookingIds, data.invoice_id?data.invoice_id:null);

            return true;
        },

        /**
         * Lets the booking result popup show again for a new result with the same status and booking ids
         * (e.g. a booking rescheduled once more); reloading its page or going back to it still does not repeat it
         *
         * @param {String} status
         * @param {Array|String|Number} bookingIds
         */
        resetBookingResultPopup: function(status, bookingIds){
            if(!Array.isArray(bookingIds)){
                bookingIds = [bookingIds];
            }
            var statusKey = this._getPopupKey(status, bookingIds, null);
            delete window[statusKey];
            if(this._isLocalStorageAvailable()){
                localStorage.removeItem(statusKey);
            }
        },

        isShowInvoicePopup: function(bookingIds, model){
            var status = model.get('status');
            var paymentProcessor = model.get('payment_processor');
            var paymentReceived = model.get('payment_received');

            //console.log(bookingIds,model);

            if(status === 'paid'){
                status = 'success';
            }
            if(paymentProcessor === 'delay' && !paymentReceived){
                status = 'delay';
            }

            if(['new'].indexOf(status) > -1){
                return false; //ignore this status
            }

            if(!Array.isArray(bookingIds)){
                bookingIds = [bookingIds];
            }
            if(this._isPopupDisplayed(status, bookingIds, model?model.get('id'):null)){
                return false; //popup already closed
            }
            this._setPopupDisplayed(status, bookingIds, model?model.get('id'):null);

            return true;
        },

        _isLocalStorageAvailable: function () {
            var test = 'test';
            try {
                localStorage.setItem(test, test);
                localStorage.removeItem(test);
                return true;
            } catch(e) {
                return false;
            }
        },

        _getPopupKey: function (status, bookingIds, invoiceId) {
            return 'hrp_' + status + '_' + bookingIds.join('_') + (invoiceId ? '_' + invoiceId : '0');
        },

        _isPopupDisplayed: function (status, bookingIds, invoiceId) {
            var statusKey = this._getPopupKey(status, bookingIds, invoiceId);
            if(window[statusKey]){
                return true; //popup already closed
            }
            if(this._isLocalStorageAvailable() && localStorage.getItem(statusKey)){
                return true;
            }
            return false;
        },

        _setPopupDisplayed: function (status, bookingIds, invoiceId) {
            var statusKey = this._getPopupKey(status, bookingIds, invoiceId);
            window[statusKey] = true;
            if(this._isLocalStorageAvailable()){
                localStorage.setItem(statusKey, 1);
            }
        },

    };

});

